import type { BookingStatus } from '../api/types.ts';

export const STATUS_LABEL: Record<BookingStatus, { label: string; tone: 'ok' | 'accent' | 'muted' | 'dark' | 'default' }> = {
  confirmed: { label: 'ยืนยันแล้ว', tone: 'dark' },
  completed: { label: 'เสร็จแล้ว', tone: 'ok' },
  no_show: { label: 'ไม่มา', tone: 'accent' },
  cancelled_customer: { label: 'ลูกค้ายกเลิก', tone: 'muted' },
  cancelled_shop: { label: 'ร้านยกเลิก', tone: 'muted' },
  rescheduled: { label: 'เลื่อนแล้ว', tone: 'muted' },
};
